import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  Legend,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

import { useMediaQuery } from "react-responsive";
import { ChartWrapper } from "../../components/ChartWrapper";
import { formatNumber } from "../../../utils/number";

/* ✅ KEEP YOUR COLORS */
const PIE_CHART_COLORS = [
  "rgba(15, 147, 168, 1)",
  "rgba(255, 137, 137, 1)",
  "rgba(157, 171, 221, 1)",
];

/* -------- LABEL -------- */
const RADIAN = Math.PI / 180;

const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
}) => {
  if (!percent) return null;

  const radius = innerRadius + (outerRadius - innerRadius) * 0.55;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="#fff"
      textAnchor="middle"
      dominantBaseline="central"
      fontSize={11}
      fontWeight={600}
    >
      {(percent * 100).toFixed(0)}%
    </text>
  );
};

/* -------- TOTAL -------- */
const getTotal = (data = []) =>
  data.reduce((sum, item) => sum + (item?.value || 0), 0);

export default function OverallQuestionAttemptAnalysis({
  data = [],
  loading = false,
}) {
  const isSmall = useMediaQuery({ query: "(max-width: 600px)" });

  const isEmpty = !data || data.length === 0;
  const total = getTotal(data);

  return (
    <ChartWrapper
      loading={loading}
      isEmpty={isEmpty}
      title="Question Attempt Analysis"
      description={`Overall distribution of correct, incorrect, and unattempted questions (Total: ${formatNumber(
        total
      )})`}
    >
      <ResponsiveContainer width="100%" height="100%">
        <PieChart margin={{ bottom: 20 }}>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"        // 🔥 centered
            cy="48%"
            innerRadius={isSmall ? 55 : 75}   // 🔥 donut style
            outerRadius={isSmall ? 100 : 130} // 🔥 bigger pie
            paddingAngle={2}
            labelLine={false}
            label={renderCustomizedLabel}
          >
            {data.map((entry, index) => (
              <Cell
                key={index}
                fill={PIE_CHART_COLORS[index % PIE_CHART_COLORS.length]}
              />
            ))}
          </Pie>

          {/* TOOLTIP */}
          <Tooltip
            formatter={(value, name) => [value, name]}
            contentStyle={{
              borderRadius: "10px",
              border: "none",
              boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
              fontSize: "13px",
            }}
          />

          {/* LEGEND (clean, no hacks) */}
          <Legend
            verticalAlign="bottom"
            wrapperStyle={{
              fontSize: "14px",
              fontWeight: 600,
              paddingTop: 10,
            }}
          />
        </PieChart>
      </ResponsiveContainer>
    </ChartWrapper>
  );
}